import { useState, useLayoutEffect, useEffect } from 'react';
import { createPortal } from 'react-dom';
// Render component.
export const Portal = ({ children, wrapperId = 'react-portal', ignoreBodyOverflow = false, }) => {
    // Manage state of portal-wrapper.
    const [wrapper, setWrapper] = useState(null);
    useLayoutEffect(() => {
        // Find the container-element (if exist).
        let element = document.getElementById(wrapperId);
        // Bool flag whether container-element has been created.
        let created = false;
        if (!element) {
            created = true;
            const wrapper = document.createElement('div');
            wrapper.setAttribute('id', wrapperId);
            document.body.appendChild(wrapper);
            element = wrapper;
        }
        // Set wrapper state.
        setWrapper(element);
        // Cleanup effect.
        return () => {
            if (created && element?.parentNode) {
                element.parentNode.removeChild(element);
            }
        };
    }, [children, wrapperId]);
    useEffect(() => {
        //If portal has children the div should not be scrollable
        if (wrapper?.innerHTML && !ignoreBodyOverflow) {
            document.body.style.overflow = 'hidden';
        }
        // Cleanup effect
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [wrapper, ignoreBodyOverflow]);
    // Return null on initial rendering.
    if (wrapper === null)
        return null;
    // Return portal-wrapper component.
    return createPortal(children, wrapper);
};
//# sourceMappingURL=Portal.js.map